<div id="page-container" class="sidebar-inverse side-scroll page-header-fixed page-header-inverse main-content-boxed">

  <!-- Header -->
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div class="content-header-section">
        <!-- Logo -->
        <div class="content-header-item">
          <img src="/assets/img/logo/logo.png" width="150">
        </div>
        <!-- </div> -->
        <!-- END Logo -->
      </div>
      <!-- END Left Section -->

      <!-- Middle Section -->
      <div class="content-header-section d-none d-lg-block">
        <ul class="nav-main-header">
          <li>
            <a [routerLink]="['/ext/dashboard']">
              <i class="si si-home d-none d-xl-inline-block"></i> Dashboard
            </a>
          </li>
          <li>
            <a [routerLink]="['/ext/console']">
              <i class="si si-flag d-none d-xl-inline-block"></i> Projects
            </a>
          </li>
        </ul>
      </div>
      <!-- END Middle Section -->

      <!-- Right Section -->
      <div class="content-header-section">

        <div class="btn-group" role="group">
          <button type="button" class="btn btn-rounded btn-dual-secondary" id="page-header-user-dropdown"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{this.currentUser.firstName}}
            <i class="fa fa-angle-down ml-5"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right min-width-150" aria-labelledby="page-header-user-dropdown">
            <!-- Toggle Side Overlay -->
            <!-- Layout API, functionality initialized in Codebase() -> uiApiLayout() -->
            <a class="dropdown-item" data-toggle="layout" [routerLink]="['account']">
              <i class="si si-wrench mr-5"></i> Settings
            </a>
            <!-- END Side Overlay -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="['/logout']">
              <i class="si si-logout mr-5"></i> Sign Out
            </a>
          </div>

        </div>
        <!-- END Right Section -->
      </div>
      <!-- END Header Content -->
    </div>

  </header>
  <!-- END Header -->

  <!-- Main Container -->
  <main id="main-container">
    <!-- Page Content -->
    <div class="content content-full">
      <router-outlet></router-outlet>
    </div>
    <!-- END Page Content -->
  </main>
  <!-- END Main Container -->

  <!-- Footer -->
  <footer id="page-footer" class="opacity-0">
    <div class="content py-20 font-size-xs clearfix">
      <div class="float-right">
        Focus CRM
        <!--<i class="fa fa-heart text-pulse"></i> by <a class="font-w600" href="http://goo.gl/vNS3I" target="_blank">pixelcave</a>-->
      </div>
      <div class="float-left">
        <a class="font-w600" href="http://www.blueboxcfg.com" target="_blank">Focus CRM</a> &copy; <span
          class="js-year-copy"></span>
      </div>
    </div>
  </footer>
  <!-- END Footer -->
</div>
<!-- END Page Container -->



// WEBPACK FOOTER //
// ./client/app/core/layout/external/external-layout.component.html